import { createContext, useContext } from 'react'
import { useCrud } from '../BackendProvider'

export interface IpStrategy {
    strategyId?: number
    realm?: string
    version: string
    versionDate: string
    content: string
}

const IpStrategyContext = createContext({
    strategies: [] as IpStrategy[],
    postStrategy: (_s: IpStrategy) => Promise.resolve(_s),
    deleteStrategy: (_s: IpStrategy) => Promise.resolve({} as object),
})

export function IpStrategyProvider({ children }: { children: React.ReactNode }) {
    const {
        data: strategies,
        postMutation: postStrategy,
        deleteMutation: deleteStrategy,
    } = useCrud<IpStrategy>('ip-strategy', s => s.strategyId)

    return (
        <IpStrategyContext.Provider value={{ strategies, postStrategy, deleteStrategy }}>
            {children}
        </IpStrategyContext.Provider>
    )
}

export function useIpStrategy() {
    return useContext(IpStrategyContext)
}
